const normalizeImageUrl = (url) => {
    if (!url) return "";
    try {
        // Decode percent-encoding and strip query parameters for comparison
        return decodeURIComponent(url).split("?")[0];
    } catch (_) {
        return url.split("?")[0];
    }
};

export const isNonFrontalImagePresent = (activeViewport, nonFrontalImages, setNonFrontalImageId) => {
    const rawImageId = activeViewport.getCurrentImageId();
    const imageURL = normalizeImageUrl(rawImageId);
    for (let i = 0; i < nonFrontalImages.length; i++) {
        if (normalizeImageUrl(nonFrontalImages[i].imageUrl) === imageURL) {
            setNonFrontalImageId(nonFrontalImages[i].imageId);
            return true;
        }
    }
    setNonFrontalImageId(null);
    return false;
};
